import EndScreen from './EndScreen';
export default EndScreen;
